<template>
  <b-container fluid class="p-0 m-0">
    <slot name="fluid"></slot>

    <!-- <div class="tw-grid tw-grid-cols-6">
            <div class="tw-col-span-6 md:tw-col-span-4 md:tw-col-start-2">
                <slot name="default"></slot>
            </div>
        </div> -->

    <b-row>
      <b-col class="d-flex align-items-center" cols="12" lg="10" offset-lg="1">
        <slot name="default"></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "BaseLayout",
};
</script>
